import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn } from '@angular/router';
import { TPageType } from '@app/interfaces/route.interface';
import { AppNavigationService } from '@app/services/app-navigation.service';
import { AppRouteService } from '@app/services/app-route.service';
import { AppService } from '@app/services/app.service';
import { UserService } from '@app/services/user.service';
import { filter } from 'rxjs';
import { map } from 'rxjs/operators';

export const userGuard: CanActivateFn = (_route, state) => {
    const appService: AppService = inject(AppService);
    const appRouteService: AppRouteService = inject(AppRouteService);
    const appNavigationService = inject(AppNavigationService);
    const user = inject(UserService).user;
    const currentPath = state.url.split('/')[1] as TPageType;

    return toObservable(appService.loading).pipe(
        filter(loading => !loading),
        map(() => {
            const activate: boolean = appRouteService.canActivate(
                currentPath.split('?')[0] as TPageType,
                state.url.split('?')[0],
                user(),
            );

            if (!activate) {
                const fallback = (Object.keys(appRouteService.routeAccess) as TPageType[]).find(
                    page =>
                        appRouteService.routeAccess[page].visibleOnMenu &&
                        appRouteService.canActivate(page, appRouteService.getPath(page), user()),
                );
                if (fallback) appNavigationService.navigateTo(fallback);
                else void appService.logout();
            }
            return activate;
        }),
    );
};
